import { CommonErrors } from '@lmc/ts-common'

export const isInsufficientSafeguardingOfficersError = (
  err: unknown
): boolean =>
  (err as { code?: number })?.code ===
  CommonErrors.Codes.insufficientSafeguardingOfficers

export const affectedSiteNames = (err: unknown): string[] => {
  const homes = (err as { data?: { homes?: Array<{ name?: string }> } })?.data
    ?.homes
  return Array.isArray(homes)
    ? homes.map((h) => h?.name).filter((n): n is string => Boolean(n))
    : []
}
